<div class="custom-widget" [class.editing]="editMode" [class.preview]="previewMode">
  <div class="editing-layer"></div>

  <iframe #iframe></iframe>
</div>
